const MESSAGES = {
  AUTHENTICATION_ERROR:
    '**Sorry!** Your username or password is invalid! Please try to log in again.',
  AUTHORIZATION_ERROR:
    '**Forbidden** Your profile is not authorized to enter this page.',
};

export const LOGIN_MESSAGES: {
  [key: string]: string;
} = {
  AUTHENTICATION_ERROR: MESSAGES.AUTHENTICATION_ERROR,
  AUTHORIZATION_ERROR: MESSAGES.AUTHORIZATION_ERROR,
  USERNAME_PASSWORD_FAILED: MESSAGES.AUTHENTICATION_ERROR,
};
